/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuredPersonInfo
 */
export interface InsuredPersonInfo {
    /**
     * 
     * @type {string}
     * @memberof InsuredPersonInfo
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InsuredPersonInfo
     */
    birthday?: Date | null;
}

/**
 * Check if a given object implements the InsuredPersonInfo interface.
 */
export function instanceOfInsuredPersonInfo(value: object): value is InsuredPersonInfo {
    return true;
}

export function InsuredPersonInfoFromJSON(json: any): InsuredPersonInfo {
    return InsuredPersonInfoFromJSONTyped(json, false);
}

export function InsuredPersonInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredPersonInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
    };
}

export function InsuredPersonInfoToJSON(json: any): InsuredPersonInfo {
    return InsuredPersonInfoToJSONTyped(json, false);
}

export function InsuredPersonInfoToJSONTyped(value?: InsuredPersonInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'birthday': value['birthday'] === null ? null : ((value['birthday'] as any)?.toISOString()),
    };
}

